<script>
import IconBraces from "@js/components/Icons/IconBraces.vue";

export default {
    name: "FeedbackTopCommentItem",
    components: {IconBraces},
    props:{
        text: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        link: {
            required: true,
            type: String,
        },
    }
}
</script>

<template>
    <div class="border-2 border-indigo-400 rounded-xl p-5 bg-[#FCFCFC] md:max-w-[465px]">
        <IconBraces  class="w-3.5 h-3.5"/>
        <p class="text-left text-sm text-gray-500 mt-2">
            {{text}}
        </p>
        <div class="flex items-center justify-between mt-2">
            <p class="text-left text-sm text-gray-500">
               {{name}}
            </p>
           <a :href="link" rel="nofollow" target="_blank">
               <img src="@img/brands/big/yandex.webp"
                    class="h-6 object-contain mb-2"
                    alt="yandex" title="yandex">
           </a>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
